(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const clips = document.querySelectorAll('video[data-wk-clip]');
  if (!clips.length || !('IntersectionObserver' in window)) return;
  const watcher = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) video.play().catch(() => {});
        else video.pause();
      });
    },
    { threshold: 0.35 }
  );
  clips.forEach((video) => watcher.observe(video));
})();
